// extracted by mini-css-extract-plugin
export var appStore = "AppDownload-module--appStore--500c7";
export var appWrapper = "AppDownload-module--appWrapper--ef089";